import React, { Fragment, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import { Typography } from "@material-ui/core";
import { DateTimeInput, SelectInput } from "./FormInputs";
import config from "../../constants/squeeze";

const validate = (values) => {
  const errors = {};
  const requiredFields = ["type"];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  return errors;
};

const RecordSqueeze = ({
  title,
  timezone,
  handleSubmit,
  error,
  valid,
  pristine,
  submitting,
  isValid,
  isWaiting,
}) => {
  const { options } = config;

  useEffect(() => {
    isValid(!pristine && valid && !submitting);
    isWaiting(submitting);
  });

  return (
    <Fragment>
      {title && (
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>
      )}
      <form noValidate onSubmit={handleSubmit}>
        <Field
          component={DateTimeInput}
          name="timestamp"
          id="squeeze-form-timestamp"
          label="Timestamp"
          timezone={timezone}
          keepLocal={true}
        />
        <Field
          component={SelectInput}
          name="type"
          id="squeeze-form-type"
          label="Type"
          options={options}
          sortOptions={false}
        />
        <Typography variant="body1" gutterBottom color="error">
          <b>{error}</b>
        </Typography>
      </form>
    </Fragment>
  );
};

export default reduxForm({ form: "RecordSqueeze", validate })(RecordSqueeze);
